import { FC } from "react";
import CustomIcon from "@/components/ui/custom-icon";
import Link from "next/link";
import S from "./index.module.scss";

interface IArrowLink {
  text: string;
  url: string;
}

const ArrowLink: FC<IArrowLink> = ({ text, url }) => {
  return (
    <Link href={url} className={S.link}>
      <span className={S.text}>{text}</span>
      <CustomIcon fileName="icon-arrow-right" />
    </Link>
  );
};

export default ArrowLink;
